import { render, staticRenderFns } from "./authentication.vue?vue&type=template&id=4b81fa2e&scoped=true"
import script from "./authentication.vue?vue&type=script&lang=js"
export * from "./authentication.vue?vue&type=script&lang=js"
import style0 from "./authentication.vue?vue&type=style&index=0&id=4b81fa2e&prod&lang=css"
import style1 from "./authentication.vue?vue&type=style&index=1&id=4b81fa2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b81fa2e",
  null
  
)

export default component.exports